import { PUMP_INVENTORY_FETCH_REQUESTED, PUMP_INVENTORY_FETCH_SUCCEEDED } from './types';
import { InventoryContextForType, InventoryType } from '../types';

export function fetchInventoryPumps() {
  return {
    type: PUMP_INVENTORY_FETCH_REQUESTED,
    payload: {},
  };
}

export function fetchInventoryPumpsSuccess(
  // @ts-ignore
  productsList: firebase.firestore.QuerySnapshot
): {
  type: string;
  payload: InventoryContextForType<InventoryType.PUMP>[];
} {
  const pumps = productsList.docs.map(
    // @ts-ignore
    (doc: firebase.firestore.DocumentData) => {
      const data = doc.data();
      return {
        ...data,
        orgId: data?.org?.id,
        orgTitle: data?.org?.title,
        id: doc.id,
        updateTime: data?.updateTime?.toDate(),
      };
    }
  );
  return {
    type: PUMP_INVENTORY_FETCH_SUCCEEDED,
    payload: pumps,
  };
}
